import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/esnext.global-this.js";
import React, { useEffect, useState } from 'react';
import { AppBar, IconButton, Container, useMediaQuery, Grid, TAGLink, Box, TAGButton, TAGTypography } from '../../../..';
import { Menu, Close, ExpandMore } from '@mui/icons-material'; // import WNResearchSearchField from './WNResearchSearchField'

import WNResearchPopover from './WNResearchPopover';
import { Popper } from '@mui/material';

var WNResearchHeader = function WNResearchHeader(props) {
  var _globalThis$location, _contentfulData$logo;

  var _useState = useState({
    anchorElNav: null,
    anchorElForMenu: null,
    showSearchInputField: false,
    searchInputValue: '',
    selectedAccordion: ''
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var contentfulData = props.contentfulData;
  var navigationGroups = contentfulData.header.navigationLinks;
  var logoUrl = contentfulData.logo.file.url;
  var brandImageLink = contentfulData.brandImageLink;
  var isMenuOpen = Boolean(state.anchorElNav);
  var isMediumAndAboveDevice = useMediaQuery('(min-width: 768px)');
  useEffect(function () {
    if (state.anchorElNav) {
      handleCloseNavMenu();
    }
  }, [globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 ? void 0 : _globalThis$location.pathname]);

  var handleOpenNavMenu = function handleOpenNavMenu(event) {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      anchorElNav: event.currentTarget
    }));
  }; // const handleSearchIconClick = () => {
  //   setState({
  //     ...state,
  //     showSearchInputField: true,
  //   })
  // }


  var handleCloseNavMenu = function handleCloseNavMenu() {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      anchorElNav: null,
      selectedAccordion: ''
    }));
  };

  var handleSearchInputChange = function handleSearchInputChange(e) {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      searchInputValue: e.currentTarget.value
    }));
  };

  var handleCloseSearchClick = function handleCloseSearchClick() {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      searchInputValue: '',
      showSearchInputField: false
    }));
  };

  var handleOpenMenu = function handleOpenMenu(event) {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      anchorElForMenu: event.currentTarget
    }));
  }; // const handleCloseMenu = () => {
  //   setState({
  //     ...state,
  //     anchorElForMenu: null,
  //   })
  // }


  var handleChange = function handleChange(accordionId) {
    return function (event, expanded) {
      event.preventDefault();
      setState(_objectSpread(_objectSpread({}, state), {}, {
        selectedAccordion: expanded ? accordionId : ''
      }));
    };
  };

  return React.createElement(AppBar, {
    position: "static",
    sx: {
      backgroundColor: 'neutrals.white',
      height: 84,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: '15px'
    }
  }, React.createElement(Container, null, React.createElement(Grid, {
    container: true,
    alignItems: "center",
    wrap: "nowrap",
    justifyContent: "flex-start"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(TAGLink, {
    href: brandImageLink
  }, React.createElement("img", {
    src: logoUrl,
    width: '150px',
    height: "unset",
    alt: ((_contentfulData$logo = contentfulData.logo) === null || _contentfulData$logo === void 0 ? void 0 : _contentfulData$logo.description) || ''
  }))), React.createElement(Grid, {
    item: true,
    container: true,
    alignItems: "center",
    spacing: 1,
    justifyContent: "flex-end"
  }, isMediumAndAboveDevice ? React.createElement(React.Fragment, null, !state.showSearchInputField && navigationGroups.slice(0, navigationGroups.length - 1).map(function (group, index) {
    var _navigationGroups$fil, _navigationGroups$fil2, _navigationGroups$fil3, _navigationGroups$fil4, _navigationGroups$fil5;

    return React.createElement(Grid, {
      item: true,
      key: "".concat(index, "-").concat(group.id)
    }, React.createElement(TAGButton, {
      buttonVariant: "Tertiary Default",
      onMouseOver: handleOpenMenu,
      id: group.id,
      href: group === null || group === void 0 ? void 0 : group.navigationGroupLink.path,
      buttonSize: "small",
      sx: {
        color: 'text.primary',
        ':hover': {
          background: 'none',
          color: 'text.primary',
          borderRadius: 0,
          borderBottom: '2px solid',
          borderBottomColor: 'tertiary.dark'
        }
      }
    }, React.createElement(Grid, {
      container: true,
      spacing: 1,
      justifyContent: "center",
      alignItems: "center"
    }, React.createElement(Grid, {
      item: true
    }, React.createElement(TAGTypography, {
      variant: "bodyMediumBook"
    }, group.navigationGroupLink.breadcrumbTitle)), group.navigationLinksForGroup && React.createElement(Grid, {
      item: true
    }, React.createElement(ExpandMore, {
      fontSize: "small",
      color: "text.primary",
      sx: {
        paddingTop: '5px'
      }
    })))), state.anchorElForMenu && Boolean((_navigationGroups$fil = navigationGroups.filter(function (navigationGroup) {
      var _state$anchorElForMen;

      return navigationGroup.id === ((_state$anchorElForMen = state.anchorElForMenu) === null || _state$anchorElForMen === void 0 ? void 0 : _state$anchorElForMen.id);
    })) === null || _navigationGroups$fil === void 0 ? void 0 : (_navigationGroups$fil2 = _navigationGroups$fil[0]) === null || _navigationGroups$fil2 === void 0 ? void 0 : (_navigationGroups$fil3 = _navigationGroups$fil2.navigationLinksForGroup) === null || _navigationGroups$fil3 === void 0 ? void 0 : _navigationGroups$fil3.length) && React.createElement(Popper, {
      id: "header-menu",
      anchorEl: state.anchorElForMenu,
      open: Boolean(state.anchorElForMenu),
      placement: "bottom-start"
    }, React.createElement(Box, {
      sx: {
        backgroundColor: 'primary.light',
        marginTop: '15px',
        borderRadius: 0,
        boxShadow: 'none'
      }
    }, React.createElement(Grid, {
      container: true,
      direction: "column",
      justifyContent: "flex-start",
      spacing: 1,
      sx: {
        '&.MuiGrid-root': {
          padding: '10px',
          marginTop: 0
        }
      }
    }, (_navigationGroups$fil4 = navigationGroups.filter(function (navigationGroup) {
      var _state$anchorElForMen2;

      return navigationGroup.id === ((_state$anchorElForMen2 = state.anchorElForMenu) === null || _state$anchorElForMen2 === void 0 ? void 0 : _state$anchorElForMen2.id);
    })) === null || _navigationGroups$fil4 === void 0 ? void 0 : (_navigationGroups$fil5 = _navigationGroups$fil4[0].navigationLinksForGroup) === null || _navigationGroups$fil5 === void 0 ? void 0 : _navigationGroups$fil5.map(function (navigationItem) {
      return React.createElement(Grid, {
        item: true,
        key: navigationItem.id,
        xs: 12
      }, React.createElement(TAGButton, {
        fullWidth: true,
        buttonVariant: "Tertiary Default",
        buttonSize: "small",
        href: navigationItem.path,
        sx: {
          display: 'flex',
          justifyContent: 'flex-start',
          color: 'text.primary',
          padding: '20px',
          '&:hover': {
            color: 'text.light',
            backgroundColor: 'backgrounds.dark'
          }
        }
      }, React.createElement(TAGTypography, {
        variant: "bodyMediumBook"
      }, navigationItem.breadcrumbTitle)));
    })))));
  }), navigationGroups.slice(navigationGroups.length - 1).map(function (group, index) {
    var _group$navigationGrou;

    return React.createElement(Grid, {
      item: true,
      key: "".concat(group.id, "-").concat(index)
    }, React.createElement(TAGButton, {
      buttonVariant: "Secondary Default",
      buttonSize: "small",
      href: group === null || group === void 0 ? void 0 : group.navigationGroupLink.buttonUrl
    }, ((_group$navigationGrou = group.navigationGroupLink) === null || _group$navigationGrou === void 0 ? void 0 : _group$navigationGrou.buttonText) || ''));
  })) : React.createElement(Grid, {
    item: true
  }, React.createElement(IconButton, {
    size: "large",
    "aria-label": "account of current user",
    "aria-controls": "menu-appbar",
    "aria-haspopup": "true",
    onClick: handleOpenNavMenu,
    color: "primary"
  }, isMenuOpen ? React.createElement(Close, null) : React.createElement(Menu, null))))), React.createElement(WNResearchPopover, {
    anchorElNav: state.anchorElNav,
    handleChange: handleChange,
    handleCloseNavMenu: handleCloseNavMenu,
    handleCloseSearchClick: handleCloseSearchClick,
    handleSearchInputChange: handleSearchInputChange,
    isMenuOpen: isMenuOpen,
    searchInputValue: state.searchInputValue,
    selectedAccordion: state.selectedAccordion,
    navigationGroups: navigationGroups
  })));
};

export default WNResearchHeader;